// Espelho do CanalCobrancaEnum (Financas / OrquestradorFinancas). Valores idênticos.
export enum CanalCobrancaEnum {
  Generico = 1,
  Pix = 2,
  Boleto = 3,
}
